import { DeleteOutlined, SearchOutlined } from "@ant-design/icons";
import { Button, Flex, Radio, Select, Spin, Table, Tooltip, Input, Tag } from "antd";
import { maskDate } from "../../../../util/utils";

const { TextArea } = Input;

export default function ManageTickets(props) {
    const { lottoId, selectedOption, handleChangeRadio, debounceFetcher,
        handleChangeTickets, loading, searchOptions, selectedTickets,
        searchText, setSearchText, handleSearchTextArea,
        tickets, callMethod, buttonTitle, buttonClass, action, handleDeleteTicketList } = props;

    const columns = [
        {
            title: 'Núm. de Ticket',
            dataIndex: 'ticketNumber',
            key: 'ticketNumber',
        },
        {
            title: 'Nombres',
            dataIndex: 'name',
            key: 'name',
        },
        {
            title: 'Apellidos',
            dataIndex: 'lastName',
            key: 'lastName',
        },
        {
            title: 'Celular',
            dataIndex: 'phone',
            key: 'phone',
        },
        {
            title: 'Estado',
            dataIndex: 'state',
            key: 'state',
        },
        {
            title: 'Fecha de Reserva',
            dataIndex: 'reservationDate',
            key: 'reservationDate',
            render: (value) => maskDate(value),
        },
        {
            title: 'Status',
            key: 'status',
            render: (_, record) => record.purchaseDate ? <Tag color="green">PAGADO</Tag> : <Tag color="red">NO PAGADO</Tag>,
        },
        {
            title: 'Acciones',
            key: 'actions',
            render: (_, record) => (
                <Tooltip title="Eliminar de lista">
                    <Button
                        type="text"
                        danger
                        icon={<DeleteOutlined />}
                        onClick={() => handleDeleteTicketList(record.ticketNumber)}
                    />
                </Tooltip>
            ),
        },
    ];

    return (
        <>
            <br />
            <Radio.Group
                name="radiogroup"
                value={selectedOption}
                onChange={handleChangeRadio}
                options={[
                    { value: 1, label: 'Por Número' },
                    { value: 2, label: 'Por Texto' },
                ]}
            />
            <br /><br />
            {selectedOption === 1 ? (
                <Select
                    mode="multiple"
                    showSearch
                    placeholder="Escribe para buscar boletos..."
                    filterOption={false}
                    onSearch={(value) => debounceFetcher(lottoId, value, action)}
                    onChange={handleChangeTickets}
                    notFoundContent={loading ? <Spin size="small" /> : null}
                    style={{ width: "100%" }}
                    options={searchOptions}
                    value={selectedTickets}
                />
            ) : (
                <Flex align="center">
                    <TextArea
                        placeholder="Escribe para buscar boletos (separados por coma)..."
                        rows={4}
                        value={searchText}
                        onChange={(e) => {
                            const value = e.target.value;
                            const filtered = value.replace(/[^0-9,]/g, "");
                            setSearchText(filtered);
                        }}
                    />
                    <Tooltip title="Buscar">
                        <Button
                            disabled={searchText.length === 0}
                            style={{ marginLeft: 10 }}
                            size="large"
                            type="primary"
                            shape="circle"
                            icon={<SearchOutlined />}
                            onClick={handleSearchTextArea}
                        />
                    </Tooltip>
                </Flex>
            )}

            <br /><br />
            <Table columns={columns} dataSource={tickets} rowKey="ticketId" />

            <br /><br />
            <div style={{ display: "flex", justifyContent: "center" }}>
                <Button
                    type="primary"
                    size="large"
                    disabled={tickets.length === 0}
                    onClick={callMethod}
                    className={buttonClass}
                >
                    {buttonTitle}
                </Button>
            </div>
        </>
    );
}